module.exports = __webpack_public_path__ + "fonts/Baskerville-Regular.0fc682f8.woff";